import React, { Component, Fragment } from "react";
import postService from "../../services/postService";
import CircularLoadingScreen from "../commons/CircularLoadingScreen";
import Post from "./Post";
import "../../resources/postList.css";
import SentimentDissatisfiedIcon from "@mui/icons-material/SentimentDissatisfied";

class PostList extends Component {
  render() {
    const { posts, noPostsError, onDelete } = this.props;

    if (posts.length == 0) {
      return (
        <div
          style={{
            color: "grey",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 20,
          }}
        >
          {noPostsError}{" "}
          <SentimentDissatisfiedIcon style={{ marginLeft: 10 }} />
        </div>
      );
    }

    return (
      <Fragment>
        {posts.map((post) => (
          <Post post={post} key={post.id} onDelete={onDelete} />
        ))}
      </Fragment>
    );
  }
}

export default PostList;
